(function initMobileNav(){
  if (window.__mobileMenuUnified__) return;
  function start(){
    if (window.__mobileMenuUnified__) return;
    window.__mobileMenuUnified__ = true;
    function qs(sel, root){ return (root||document).querySelector(sel); }
    const html = document.documentElement;
    const body = document.body;
    const btn = qs('[data-action="toggle-mobile-nav"]');
    const nav = qs('#mobile-nav');
    if (!btn || !nav) return;
    if (btn.tagName === 'BUTTON' && btn.type !== 'button') { btn.type = 'button'; }
    if (btn.tagName === 'A') {
      var href = btn.getAttribute('href') || '';
      if (href === '' || href === '#' || href === location.href || href === location.pathname) {
        btn.setAttribute('data-orig-href', href);
        btn.setAttribute('href', 'javascript:void(0)');
      }
    }
    function findGloboTrigger(){
      return qs('.globo-mega-menu [aria-expanded], .globo-mega-menu .gm-navbar-toggle, .globo-mega-menu .gm-toggle, .globo-mega-menu [data-gm-toggle], .globo-mega-menu [data-toggle]');
    }
    function openGlobo(){
      const trg = findGloboTrigger();
      if (trg && trg.getAttribute && trg.getAttribute('aria-expanded') !== 'true') trg.click();
    }
    function closeGlobo(){
      const trg = qs('.globo-mega-menu [aria-expanded="true"]');
      if (trg) trg.click();
    }
    let backdrop = qs('#mobile-nav-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('button');
      backdrop.id = 'mobile-nav-backdrop';
      backdrop.type = 'button';
      backdrop.setAttribute('aria-label', 'Menü schließen');
      backdrop.setAttribute('data-no-instant','');
      body.appendChild(backdrop);
    }
    let removedInstantIntensity = null;
    const isOpen = () => html.classList.contains('mobile-nav-open');
    function pauseInstant(){
      if (body.hasAttribute('data-instant-intensity')) {
        removedInstantIntensity = body.getAttribute('data-instant-intensity');
        body.removeAttribute('data-instant-intensity');
      }
    }
    function resumeInstant(){
      if (removedInstantIntensity !== null) {
        body.setAttribute('data-instant-intensity', removedInstantIntensity);
        removedInstantIntensity = null;
      }
    }
    const navFreeze = { active:false, assign:null, replace:null, reload:null, push:null, rep:null };
    function enableNavFreeze(){
      if (navFreeze.active) return;
      navFreeze.active = true;
      try {
        navFreeze.assign  = window.location.assign.bind(window.location);
        navFreeze.replace = window.location.replace.bind(window.location);
        navFreeze.reload  = window.location.reload ? window.location.reload.bind(window.location) : null;
        navFreeze.push    = history.pushState.bind(history);
        navFreeze.rep     = history.replaceState.bind(history);
        window.location.assign = function(url){};
        window.location.replace = function(url){};
        if (navFreeze.reload) window.location.reload = function(){};
        history.pushState = function(state,title,url){};
        history.replaceState = function(state,title,url){};
      } catch(_) {}
    }
    function disableNavFreeze(){
      if (!navFreeze.active) return;
      navFreeze.active = false;
      try {
        if (navFreeze.assign)  window.location.assign  = navFreeze.assign;
        if (navFreeze.replace) window.location.replace = navFreeze.replace;
        if (navFreeze.reload)  window.location.reload  = navFreeze.reload;
        if (navFreeze.push)    history.pushState       = navFreeze.push;
        if (navFreeze.rep)     history.replaceState    = navFreeze.rep;
      } catch(_) {}
    }
    function openMenu(){
      html.classList.add('mobile-nav-open');
      btn.setAttribute('aria-expanded','true');
      nav.setAttribute('aria-hidden','false');
      openGlobo();
      pauseInstant();
      enableNavFreeze();
    }
    function closeMenu(){
      html.classList.remove('mobile-nav-open');
      btn.setAttribute('aria-expanded','false');
      nav.setAttribute('aria-hidden','true');
      closeGlobo();
      disableNavFreeze();
      resumeInstant();
    }
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      isOpen() ? closeMenu() : openMenu();
    }, { passive:false });
    backdrop.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      closeMenu();
    }, { passive:false });
    function killOutside(e){
      if (!isOpen()) return;
      const insideMenu = nav.contains(e.target) || btn.contains(e.target) || e.target.closest('.globo-mega-menu');
      if (insideMenu) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      closeMenu();
    }
    ['touchstart','touchend','pointerdown','pointerup','click'].forEach(evt=>{
      document.addEventListener(evt, killOutside, { capture:true, passive:false });
    });
    document.addEventListener('keydown', function(e){
      if (!isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); closeMenu(); }
    }, { capture:true });
    let syncing = false;
    const mo = new MutationObserver(() => {
      if (syncing) return;
      syncing = true;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded && !isOpen()) openMenu();
      if (!expanded && isOpen()) closeMenu();
      syncing = false;
    });
    mo.observe(btn, { attributes:true, attributeFilter:['aria-expanded'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once:true });
  } else {
    start();
  }
})();


(function initCartDeliveryEstimate() {
  if (window.__cartDeliveryEstimateInitialized__) return;
  window.__cartDeliveryEstimateInitialized__ = true;

  var HOLIDAY_CACHE = {};

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function dateKey(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function addDays(date, days) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    result.setDate(result.getDate() + days);
    return result;
  }

  function getEasterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    var day = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(year, month, day);
  }

  function getLowerSaxonyHolidayKeys(year) {
    if (HOLIDAY_CACHE[year]) return HOLIDAY_CACHE[year];

    var holidays = new Set();
    var easter = getEasterSunday(year);

    [
      new Date(year, 0, 1),
      new Date(year, 4, 1),
      new Date(year, 9, 3),
      new Date(year, 9, 31),
      new Date(year, 11, 25),
      new Date(year, 11, 26),
      addDays(easter, -2),
      addDays(easter, 1),
      addDays(easter, 39),
      addDays(easter, 50)
    ].forEach(function(date) {
      holidays.add(dateKey(date));
    });

    HOLIDAY_CACHE[year] = holidays;
    return holidays;
  }

  function isBusinessDay(date) {
    var day = date.getDay();

    if (day === 0 || day === 6) {
      return false;
    }

    return !getLowerSaxonyHolidayKeys(date.getFullYear()).has(dateKey(date));
  }

  function addBusinessDays(baseDate, businessDays) {
    var date = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
    var addedDays = 0;

    while (addedDays < businessDays) {
      date.setDate(date.getDate() + 1);

      if (isBusinessDay(date)) {
        addedDays += 1;
      }
    }

    return date;
  }

  function parseAvailability(text) {
    if (!text) return null;

    var normalized = String(text)
      .replace(/\s+/g, ' ')
      .replace(/[–—]/g, '-')
      .trim();

    if (!/bestellartikel/i.test(normalized)) {
      return null;
    }

    var weeksMatch = normalized.match(/(\d+)\s*wochen?/i);

    if (weeksMatch) {
      var weekDays = parseInt(weeksMatch[1], 10) * 5;

      return {
        min: weekDays,
        max: weekDays,
        source: normalized
      };
    }

    var rangeMatch = normalized.match(/(\d+)\s*(?:-|bis)\s*(\d+)\s*werktage?/i);

    if (rangeMatch) {
      return {
        min: parseInt(rangeMatch[1], 10),
        max: parseInt(rangeMatch[2], 10),
        source: normalized
      };
    }

    var singleMatch = normalized.match(/(\d+)\s*werktage?/i);

    if (singleMatch) {
      var days = parseInt(singleMatch[1], 10);

      return {
        min: days,
        max: days,
        source: normalized
      };
    }

    return null;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  }

  function getSlowestDeliveryRange() {
    var sources = Array.prototype.slice.call(document.querySelectorAll('[data-delivery-availability]'));
    var ranges = sources
      .map(function(source) {
        return parseAvailability(source.getAttribute('data-delivery-availability'));
      })
      .filter(Boolean);

    if (!ranges.length) {
      return null;
    }

    ranges.sort(function(a, b) {
      if (a.max !== b.max) return b.max - a.max;
      return b.min - a.min;
    });

    return ranges[0];
  }

  function updateDeliveryEstimates() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-cart-delivery-estimate]'));

    if (!targets.length) {
      return;
    }

    var slowestRange = getSlowestDeliveryRange();

    if (!slowestRange) {
      targets.forEach(function(target) {
        target.hidden = true;
        target.setAttribute('aria-hidden', 'true');
      });
      return;
    }

    var today = new Date();
    var startDate = addBusinessDays(today, slowestRange.min);
    var endDate = addBusinessDays(today, slowestRange.max);
    var dateText = slowestRange.min === slowestRange.max
      ? 'ca. ' + formatDate(endDate)
      : 'ca. ' + formatDate(startDate) + ' – ' + formatDate(endDate);

    targets.forEach(function(target) {
      var dateTarget = target.querySelector('[data-cart-delivery-estimate-date]');

      if (dateTarget && dateTarget.textContent !== dateText) {
        dateTarget.textContent = dateText;
      }

      target.hidden = false;
      target.setAttribute('aria-hidden', 'false');
    });
  }

  var updateTimer = null;

  function scheduleUpdate() {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateDeliveryEstimates, 80);
  }

  document.addEventListener('DOMContentLoaded', updateDeliveryEstimates);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.documentElement.addEventListener('cart:refresh', scheduleUpdate);
  document.documentElement.addEventListener('cart:rerendered', scheduleUpdate);
  document.documentElement.addEventListener('product:added', scheduleUpdate);

  if ('MutationObserver' in window) {
    new MutationObserver(scheduleUpdate).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  updateDeliveryEstimates();
})();